import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { REPORTS_CANCELLED_DATA } from "../_mock/mock";
const headLabel = [
  {
    id: 1,
    label: "AR Confirmed Date",
    value: "arConfirmedDate",
  },

  {
    id: 2,
    label: "AD 11 Rate_Cout 1 ",
    value: "rateCout",
  },
];
const tableData = [
  {
    arConfirmedDate: "2024-02-25",
    rateCout: 5,
  },
  {
    arConfirmedDate: "2024-02-26",
    rateCout: 10,
  },
  {
    arConfirmedDate: "2024-02-27",
    rateCout: 7,
  },
  {
    arConfirmedDate: "2024-02-28",
    rateCout: 12,
  },
  {
    arConfirmedDate: "2024-02-29",
    rateCout: 3,
  },
];

export default function ReportsBedOccupancyTable() {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="master ward table" sx={{ minWidth: 800 }}>
        <TableHead
          sx={{
            backgroundColor: "#f5f5f5",
            "& th": { fontWeight: "bold" },
          }}
        >
          <TableRow>
            {headLabel?.map((option) => (
              <TableCell
                key={option?.id}
                sx={{ textAlign: option?.align || "left" }}
              >
                {option?.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData?.map((row) => (
            <TableRow key={row?._id}>
              {headLabel?.map((column, index) => (
                <TableCell key={column?.id}>
                  {column?.value === "active"
                    ? row?.[column?.value]
                      ? "Active"
                      : "Inactive"
                    : row?.[column?.value] || "-"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
